// Icône stylisée en pastille circulaire pour chaque catégorie et ambiance.
// Contour sauge, remplissage doux, inspiré des mocks Soft Landing ASMR.
import {
  Briefcase, Coffee, Sparkles, Leaf, Wind, Moon,
  Music, Baby, Cloud, Waves, Circle, TreePine, Headphones,
} from "lucide-react";

const MAP = {
  // catégories
  pression: Briefcase,
  decompression: Coffee,
  soiree: Sparkles,
  pause: Leaf,
  tensions: Wind,
  sommeil: Moon,
  sport: TreePine,
  musique: Music,
  bebe: Baby,
  // ambiances
  pink: Circle,
  brown: Circle,
  rain: Cloud,
  ocean: Waves,
  forest: TreePine,
  headphones: Headphones,
};

export default function CategoryIcon({ id, size = 48, className = "" }) {
  const Icon = MAP[id] || Leaf;
  const px = size;
  return (
    <div
      data-testid={`cat-icon-${id}`}
      className={`rounded-full flex items-center justify-center flex-shrink-0 ${className}`}
      style={{
        width: px, height: px,
        background: "radial-gradient(circle at 30% 30%, rgba(178,197,188,0.22), rgba(74,107,93,0.10))",
        border: "1px solid rgba(136,160,150,0.35)",
        boxShadow: "inset 0 0 12px rgba(178,197,188,0.10)",
      }}
    >
      <Icon size={Math.round(px * 0.42)} strokeWidth={1.4} className="text-[color:var(--sauge-light)]" />
    </div>
  );
}
